module.exports = __webpack_public_path__ + "static/img/encased-uranium-cell_64.9bfd6bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/encased-uranium-cell_64.png
// module id = 0ZWI
// module chunks = 0